/* TailTrove – cohérence du complément HD dans le panier (Fase 1B, révisé Fase 1C)
 * Règles appliquées à chaque chargement, après chaque mise à jour du panier et juste avant le paiement :
 *  - une ligne « Fichier numérique HD – en complément » sans référence (_tt_ref) est retirée ;
 *  - une ligne HD dont le portrait (« Réf. portrait ») n'est plus dans le panier est retirée ;
 *  - une seule ligne HD par portrait, quantité 1 (un fichier par portrait, quelle que soit la quantité imprimée).
 * Fase 1C : erreurs HTTP détectées (nouvel essai, puis message) ; sur la page /cart la page est rechargée
 * pour mettre à jour les totaux ; clic sur « Paiement » retenu tant qu'un HD est en cours d'ajout
 * (window.__ttHdPending) ou que la vérification n'a pas abouti.
 * Fase 1D (configuration de lancement) : HD_ENABLED = false. Le complément HD n'est plus proposé :
 *  - aucune interception du bouton « Paiement » (le paiement ne dépend plus de ce script) ;
 *  - toute ligne ancienne du complément est retirée du panier avec un message clair.
 * Le code HD est conservé : remettre HD_ENABLED = true (avec hd_enabled dans tt-pdp-photo.liquid) après tests réels.
 * Limite : règle appliquée par le thème (navigateur). Elle ne bloque pas un accès direct au checkout
 * (lien de panier, navigateur sans JavaScript) ; une validation côté serveur exige une fonction Shopify (application).
 */
(function () {
  'use strict';
  if (window.__ttCartSync) return;
  window.__ttCartSync = true;
  var HD_ENABLED = false; // configuration de lancement : complément HD suspendu
  var HANDLE = 'fichier-numerique-complement';
  var removedOld = false;
  var running = null, again = false, lastOk = true;
  var onCartPage = /\/cart\/?$/.test(location.pathname);

  function plan(cart) {
    if (!HD_ENABLED) {
      return cart.items.filter(function (it) { return it.handle === HANDLE; }).map(function (it) { return { id: it.key, quantity: 0 }; });
    }
    var refs = {};
    cart.items.forEach(function (it) {
      var r = it.properties && it.properties['Réf. portrait'];
      if (r && it.handle !== HANDLE) refs[r] = true;
    });
    var seen = {}, changes = [];
    cart.items.forEach(function (it) {
      if (it.handle !== HANDLE) return;
      var r = it.properties && it.properties._tt_ref;
      if (!r || !refs[r] || seen[r]) { changes.push({ id: it.key, quantity: 0 }); return; }
      seen[r] = true;
      if (it.quantity !== 1) changes.push({ id: it.key, quantity: 1 });
    });
    return changes;
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) {
      if (!r.ok) throw new Error('cart.js HTTP ' + r.status);
      return r.json();
    });
  }
  function change(c) {
    return fetch((window.routes && routes.cart_change_url || '/cart/change') + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(c)
    }).then(function (r) {
      if (!r.ok) throw new Error('change.js HTTP ' + r.status);
      return r.json();
    });
  }
  function apply(changes) {
    return changes.reduce(function (p, c) { return p.then(function () { return change(c); }); }, Promise.resolve());
  }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  /* Une passe : lit le panier, corrige, relit pour confirmer. Renvoie true si quelque chose a changé. */
  function pass() {
    return getCart().then(function (cart) {
      var ch = plan(cart);
      if (!ch.length) return false;
      if (!HD_ENABLED) removedOld = true;
      return apply(ch).then(getCart).then(function (c2) {
        if (plan(c2).length) throw new Error('panier encore incohérent');
        return true;
      });
    });
  }

  function sync() {
    if (running) { again = true; return running; }
    running = pass().catch(function () { return wait(1500).then(pass); })
      .then(function (changed) {
        lastOk = true;
        if (removedOld) { try { sessionStorage.setItem('tt-hd-removed', '1'); } catch (e) {} }
        if (changed && onCartPage) { location.reload(); return true; } // le pied de page /cart (totaux) n'est pas re-rendu par Dawn ; message affiché après rechargement
        showRemoved();
        if (!changed) return false;
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'tt-cart-sync' });
        return true;
      }, function (err) {
        lastOk = false;
        if (window.console) console.warn('[TailTrove] vérification du panier impossible :', err && err.message);
        return false;
      })
      .then(function (r) {
        running = null;
        if (again) { again = false; return sync(); }
        return r;
      });
    return running;
  }

  /* ---------- message : complément retiré ---------- */
  function showRemoved() {
    var flag = removedOld; try { flag = flag || sessionStorage.getItem('tt-hd-removed') === '1'; } catch (e) {}
    if (!flag) return;
    var host = document.querySelector('#main-cart-items') || document.querySelector('#CartDrawer .drawer__inner');
    if (!host || document.getElementById('tt-hd-removed')) return;
    var p = document.createElement('p'); p.id = 'tt-hd-removed'; p.setAttribute('role', 'status');
    p.style.cssText = 'margin:1rem 0;padding:.8rem 1rem;border-radius:8px;background:#fff6e5;font-size:1.4rem';
    p.textContent = 'Le fichier numérique HD en complément n\'est plus proposé : il a été retiré de votre panier (rien ne vous est facturé pour lui). Votre portrait reste dans le panier ; le fichier numérique seul est disponible sur sa propre page.';
    host.insertBefore(p, host.firstChild);
    try { sessionStorage.removeItem('tt-hd-removed'); } catch (e) {}
  }

  /* ---------- garde avant paiement (seulement si HD_ENABLED) ---------- */
  var released = false;
  function notice(btn, text) {
    var id = 'tt-checkout-note', el = document.getElementById(id);
    if (!el) { el = document.createElement('p'); el.id = id; el.setAttribute('role', 'status'); el.style.cssText = 'margin:.8rem 0;padding:.8rem 1rem;border-radius:8px;background:#fdecea;color:#8c1d18;font-size:1.4rem'; }
    if (btn && btn.parentNode && el.parentNode !== btn.parentNode) btn.parentNode.insertBefore(el, btn);
    el.textContent = text || ''; el.hidden = !text;
  }
  function waitHd(maxMs) {
    var t0 = Date.now();
    return new Promise(function (res) {
      (function tick() { if (!window.__ttHdPending || Date.now() - t0 > maxMs) return res(!window.__ttHdPending); setTimeout(tick, 150); })();
    });
  }
  if (HD_ENABLED) document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[name="checkout"], a[href*="/checkout"]');
    if (!btn) return;
    if (released) { released = false; return; }
    e.preventDefault(); e.stopImmediatePropagation();
    if (btn.__ttBusy) return;
    btn.__ttBusy = true; btn.setAttribute('aria-busy', 'true');
    notice(btn, window.__ttHdPending ? 'Ajout du fichier numérique HD en cours… un instant.' : '');
    waitHd(15000).then(function (hdDone) {
      if (!hdDone) throw new Error('hd');
      return sync();
    }).then(function () {
      if (!lastOk) throw new Error('sync');
      btn.__ttBusy = false; btn.removeAttribute('aria-busy'); notice(btn, '');
      released = true;
      if (btn.tagName === 'A') { released = false; location.href = btn.href; } else btn.click();
    }).catch(function () {
      btn.__ttBusy = false; btn.removeAttribute('aria-busy');
      notice(btn, 'Votre panier n\'a pas pu être vérifié. Actualisez la page puis réessayez.');
    });
  }, true);

  window.ttCartSync = { sync: sync, plan: plan };
  function init() {
    sync();
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (d) {
        if (d && d.source === 'tt-cart-sync') return;
        setTimeout(sync, 250);
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
